import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  items: {
    defaultMessage: 'Total received items: {reportedItems}/{totalItems}',
    id: 'krgbaW',
    description: 'received and remaining items amounts',
  },
});
